import { baseUrl, UPDATE_MEMBER_GET_ERROR } from "../../constants";
import serverApiV2Instance from "../../services/serverApiV2Instance";

export const getMemberLoginAttempt = (memberId) =>
  serverApiV2Instance.get(`/members/${memberId}/analytics`);
